import {createAction} from "redux-act";
import {IPlayerPoolFilters} from "modules/types";
import {PlayerPositionEnum} from "modules/enums";

export const setIsOpenPlayerPool = createAction<boolean>();

export const updatePlayerPoolFilters = createAction<IPlayerPoolFilters>();

export const clearPlayerPoolState = createAction();

export const setPlayerPoolFilterPosition = createAction<PlayerPositionEnum>();
